function initNav() {
    const isInNav = () => $('.js-nav-global :focus').length > 0;
    const $currentSubmenu = () => $('.js-nav-global .submenu.active').parent('.menu-item').find('> a');

    const $mainMenu = $('.js-nav-global .menu').first();
    const $submenuTogglers = $mainMenu.find('.menu-item-has-children > a > .toggler');

    // The icon switch-aroo
    const $icons = $('.header-wrapper .icon-menu');

    function openMenu() {
        $icons.toggleClass('active');
        $('.js-nav-global').addClass('active');
        $('#icon-menu-open').attr('aria-expanded', 'true');
        $('#icon-menu-close').attr('aria-hidden', 'false');
    }

    function closeMenu() {
        $icons.toggleClass('active');
        $('.js-nav-global').removeClass('active');
        $('#icon-menu-open').attr('aria-expanded', 'false');
        $('#icon-menu-close').attr('aria-hidden', 'true');
    }

    function mobileNavToggle() {
        if ($('.js-nav-global').hasClass('active')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    // Takes a parent link and opens the corresponding submenu
    function openSubmenu(el) {
        const $thisItem = $(el).parent('.menu-item');

        $thisItem.addClass('active').find('> .submenu').addClass('active');
        $thisItem.find('> a').attr('aria-expanded', true);
    }

    function closeSubmenu(el) {
        const $thisItem = $(el).parent('.menu-item');

        $thisItem.removeClass('active').find('> .submenu').removeClass('active');
        $thisItem.find('> a').attr('aria-expanded', false);
    }

    function closeAllSubmenus() {
        $.each($('.menu-item-has-children > a'), (index, node) => {
            closeSubmenu(node);
        });
    }

    /* ----------  Bind Events  ----------*/
    $icons.on('click', () => {
        mobileNavToggle();
    });

    // Open menu by pressing return
    $icons.keydown((event) => {
        if (event.keyCode === 13) {
            mobileNavToggle();
        }
    });

    // Keyboard events
    $(document).keyup((event) => {
        // Escape
        if (event.keyCode === 27) {
            if ($currentSubmenu().length > 0) {
                closeSubmenu($currentSubmenu());
            } else if ($('.js-nav-global').hasClass('active')) {
                closeMenu();
            }
        }

        // Tab
        if (event.keyCode === 9) {
            // Hide all submenus if user tabs out
            if (!isInNav()) closeAllSubmenus();
        }

        // Left arrow
        if (event.keyCode === 37) {
            if (isInNav() && $currentSubmenu().length > 0) {
                closeSubmenu(event.target);
            }
        }

        // Right arrow
        if (event.keyCode === 39) {
            if (isInNav()) {
                openSubmenu(event.target);
            }
        }
    });

    // Toggle submenus when a parent item is clicked
    $submenuTogglers.on('click', (event) => {
        event.preventDefault();
        const $thisLink = $(event.target).parent('a');
        const $thisItem = $thisLink.parent('.menu-item');
        const $adjacentItems = $thisItem.parent('.menu').find('> .menu-item-has-children > a');

        if ($thisItem.hasClass('active')) {
            closeSubmenu($thisLink);
        } else {
            // Reset all submenus in at this level
            $.each($adjacentItems, (index, node) => {
                closeSubmenu(node);
            });

            openSubmenu($thisLink);
        }
    });

    // Hide all submenus if user clicks outside of menu
    $(document).on('click', (event) => {
        if ($(event.target).parents('.js-nav-global').length < 1) {
            closeAllSubmenus();
        }
    });
}

jQuery(document).ready(() => {
    initNav();
});
